import { useEffect, useRef } from "react";
import { useGlobalContext } from "../components/context/SocketContext";
import {
  LIVE_BOARD_UPDATE_EVENT,
  gamesFromLiveBoardUpdate,
} from "../utility/liveBoardScoreRefresh";

export const LIVE_BOARD_SOCKET_DEBOUNCE_MS = 400;

/**
 * Subscribe to server LIVE_BOARD_UPDATE pushes (slim score deltas).
 */
export function useLiveBoardSocket(
  onLiveGames,
  { enabled = true, debounceMs = LIVE_BOARD_SOCKET_DEBOUNCE_MS } = {}
) {
  const { socket } = useGlobalContext();
  const handlerRef = useRef(onLiveGames);
  handlerRef.current = onLiveGames;

  useEffect(() => {
    if (!enabled || !socket) return undefined;

    let debounceTimer = null;
    /** @type {Array<object>} */
    let pendingById = new Map();

    const flush = () => {
      debounceTimer = null;
      if (!pendingById.size) return;
      const batch = [...pendingById.values()];
      pendingById = new Map();
      handlerRef.current(batch);
    };

    const onUpdate = (payload) => {
      const games = gamesFromLiveBoardUpdate(payload);
      if (!games.length) return;
      for (const game of games) {
        if (game?.id) pendingById.set(game.id, game);
      }
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(flush, debounceMs);
    };

    socket.on(LIVE_BOARD_UPDATE_EVENT, onUpdate);
    return () => {
      socket.off(LIVE_BOARD_UPDATE_EVENT, onUpdate);
      if (debounceTimer) clearTimeout(debounceTimer);
    };
  }, [socket, enabled, debounceMs]);
}
